import React from 'react';

import Content from '../../../Content';

import {IContentfulEmbeddedAssetProps} from './IContentfulEmbeddedAsset';

const ContentfulEmbeddedAsset = ({data}: IContentfulEmbeddedAssetProps): React.ReactElement => {
	return (
		<div className="text__img-wrapper">
			<Content data={data.target} />
		</div>
	);
};

export default ContentfulEmbeddedAsset;
